export const privacyHero = {
  title: 'プライバシーポリシー',
  titleEn: 'PRIVACY POLICY',
  lead: '一般社団法人全日本執事協会（以下「当協会」）は、日本執事アカデミーの運営にあたり取得する個人情報の取扱いについて、以下の方針を定め、適切に管理いたします。',
};

export interface PrivacyArticle {
  id: string;
  number: number;
  title: string;
  content: string[];
}

export const privacyArticles: PrivacyArticle[] = [
  {
    id: 'article-01',
    number: 1,
    title: '事業者情報',
    content: [
      '当協会は、日本執事アカデミーを運営する一般社団法人です。当サイトおよび当アカデミーに関する個人情報の取扱いについては、当協会が責任を負います。',
      '名称：一般社団法人 全日本執事協会',
      '所在地：東京都江東区青海2-7-4',
      '電話番号：03-6824-4086（平日 10:00〜17:00）',
      'メールアドレス：info@butler-academy.jp',
    ],
  },
  {
    id: 'article-02',
    number: 2,
    title: '取得する個人情報',
    content: [
      '当協会は、以下の場面において、お客様の個人情報を取得いたします。',
      '資料請求時：氏名、ふりがな、メールアドレス、電話番号（任意）、ご興味のあるコース（任意）',
      '個別相談お申込み時：氏名、ふりがな、メールアドレス、電話番号、ご相談内容、ご希望の日時',
      '各種お申込み・お問い合わせ時：氏名、ふりがな、メールアドレス、電話番号、その他お客様が入力された情報',
      '法人研修のお問い合わせ時：企業名、ご担当者名、部署名、メールアドレス、電話番号、ご相談内容',
    ],
  },
  {
    id: 'article-03',
    number: 3,
    title: '利用目的',
    content: [
      '取得した個人情報は、以下の目的に限り利用いたします。',
      '（1）お申込み・お問い合わせへの対応',
      '（2）資料の送付（PDF）',
      '（3）講座・サービスに関するご案内とご連絡',
      '（4）サービスの品質向上のための分析',
      '（5）法令に基づく対応',
      '上記の目的を超えて個人情報を利用する場合は、あらかじめご本人の同意を得るものといたします。',
    ],
  },
  {
    id: 'article-04',
    number: 4,
    title: '第三者提供',
    content: [
      '当協会は、以下のいずれかに該当する場合を除き、ご本人の同意なく個人情報を第三者に提供いたしません。',
      '（1）法令に基づく場合',
      '（2）人の生命、身体または財産の保護のために必要がある場合であって、ご本人の同意を得ることが困難であるとき',
      '（3）公衆衛生の向上または児童の健全な育成の推進のために特に必要がある場合であって、ご本人の同意を得ることが困難であるとき',
      '（4）国の機関もしくは地方公共団体またはその委託を受けた者が法令の定める事務を遂行することに対して協力する必要がある場合であって、ご本人の同意を得ることにより当該事務の遂行に支障を及ぼすおそれがあるとき',
    ],
  },
  {
    id: 'article-05',
    number: 5,
    title: '外部委託',
    content: [
      '当協会は、利用目的の達成に必要な範囲内で、個人情報の取扱いの全部または一部を外部に委託する場合があります。',
      '委託にあたっては、個人情報の安全管理が図られるよう、委託先に対する必要かつ適切な監督を行います。',
      '具体的には、システムの保守・運用業務、メール配信業務等において、外部事業者に委託することがございます。',
    ],
  },
  {
    id: 'article-06',
    number: 6,
    title: '安全管理措置',
    content: [
      '当協会は、個人情報の漏えい、滅失または毀損の防止その他の個人情報の安全管理のために、必要かつ適切な措置を講じます。',
      '具体的には、アクセス制限、ウイルス対策、情報の暗号化、従業者に対する教育・監督等の措置を実施しております。',
      'ただし、インターネットの性質上、情報の完全な安全性を保証するものではありません。当協会は、合理的な範囲でセキュリティの向上に努めてまいります。',
    ],
  },
  {
    id: 'article-07',
    number: 7,
    title: '開示・訂正・削除等の請求',
    content: [
      'ご本人から、当協会が保有する自己の個人データについて、開示、訂正、追加、削除、利用停止、消去または第三者提供の停止（以下「開示等」といいます）のご請求があった場合、法令に従い、ご本人確認のうえ、合理的な期間内に対応いたします。',
      '開示等のご請求は、下記のお問い合わせ窓口までご連絡ください。',
      'なお、開示請求にあたっては、実費相当額の手数料を申し受ける場合がございます。あらかじめご了承ください。',
    ],
  },
  {
    id: 'article-08',
    number: 8,
    title: 'Cookie（クッキー）およびアクセス解析の利用',
    content: [
      '当サイトでは、アクセス解析およびサービス向上のため、CookieやGoogle Analytics等のアクセス解析ツールを利用する場合があります。',
      'Cookieは、お客様のブラウザに保存される小さなテキストファイルであり、サイトの利用状況を把握するために用いられます。',
      'お客様は、ブラウザの設定によりCookieの受け入れを拒否したり、削除したりすることができます。ただし、Cookieを無効化した場合、当サイトの一部機能が正しく動作しない可能性がございます。',
    ],
  },
  {
    id: 'article-09',
    number: 9,
    title: 'お問い合わせ窓口',
    content: [
      '本プライバシーポリシーに関するご質問や、個人情報の取扱いに関するお問い合わせは、下記までご連絡ください。',
      '一般社団法人 全日本執事協会 個人情報保護担当',
      'メールアドレス：info@butler-academy.jp',
      '電話番号：03-6824-4086（平日 10:00〜17:00）',
      '受付後、内容を確認のうえ、担当者よりご連絡いたします。',
    ],
  },
  {
    id: 'article-10',
    number: 10,
    title: '改定について',
    content: [
      '当協会は、法令の改正や事業内容の変更等に伴い、本プライバシーポリシーを予告なく改定する場合があります。',
      '重要な変更がある場合は、当サイト上でお知らせいたします。',
      '改定後のプライバシーポリシーは、当サイトに掲載した時点で効力を生じるものといたします。',
      '制定日：準備中',
    ],
  },
];

export const privacyRelatedLinks = [
  {
    label: '利用規約',
    href: '/terms',
    description: '当サイトのご利用にあたっての条件を定めています。',
  },
  {
    label: '特定商取引法に基づく表記',
    href: '/commercial-law',
    description: '特定商取引に関する法律に基づく表示事項です。',
  },
  {
    label: 'お問い合わせ',
    href: '/contact',
    description: 'ご質問やご不明な点はこちらからお問い合わせください。',
  },
];